import { getSession } from '../../api';

const STORAGE_PREFIX = 'docuvault_renewal_tasks_';

function getStorageKey() {
  const userId = getSession()?.id;
  return `${STORAGE_PREFIX}${encodeURIComponent(userId || 'local')}`;
}

export function getRenewalTaskStatuses() {
  try {
    const statuses = JSON.parse(localStorage.getItem(getStorageKey()) || '{}');
    return statuses && typeof statuses === 'object' && !Array.isArray(statuses) ? statuses : {};
  } catch {
    return {};
  }
}

export function setRenewalTaskStatus(docId, complete) {
  try {
    const statuses = getRenewalTaskStatuses();
    const next = { ...statuses, [String(docId)]: Boolean(complete) };
    localStorage.setItem(getStorageKey(), JSON.stringify(next));
    return next;
  } catch {
    return getRenewalTaskStatuses();
  }
}

export function clearRenewalTaskStatus(docId) {
  try {
    const statuses = getRenewalTaskStatuses();
    delete statuses[String(docId)];
    localStorage.setItem(getStorageKey(), JSON.stringify(statuses));
    return statuses;
  } catch {
    return getRenewalTaskStatuses();
  }
}